import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import { InlineTextButton, Heading, LayoutSingleColumn, Logo } from '../../components';

import css from './LoadableComponentErrorBoundary.module.css';

/**
 * Fallback shown for any uncaught render error other than a ChunkLoadError
 * (see LoadableComponentErrorBoundary.js) -- previously these fell through
 * to re-rendering the same broken children, which throws again and takes
 * the whole app blank with no feedback, in dev and production alike.
 */
export const GenericErrorBoundaryPage = () => {
  const handleReload = () => {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  };

  return (
    <div>
      <LayoutSingleColumn
        topbar={
          <div className={css.topbar}>
            <Logo className={css.logoMobile} layout="mobile" />
            <Logo className={css.logoDesktop} layout="desktop" />
          </div>
        }
        footer={null}
      >
        <div className={css.root}>
          <div className={css.content}>
            <Heading as="h1" rootClassName={css.heading}>
              <FormattedMessage id="GenericErrorBoundaryPage.heading" />
            </Heading>
            <p className={css.description}>
              <FormattedMessage id="GenericErrorBoundaryPage.description" />
            </p>
            <InlineTextButton onClick={handleReload}>
              <FormattedMessage id="GenericErrorBoundaryPage.reloadLink" />
            </InlineTextButton>
          </div>
        </div>
      </LayoutSingleColumn>
    </div>
  );
};
